import { States } from 'safe'
import {
  SET_PAYMENT_METHODS,
  PaymentMethodsTypes,
} from '../actions/actionTypes'

const initialState: States.PaymentMethod = {
  payment_methods: [],
}

//eslint-disable-next-line
export default (
  state = initialState,
  action: PaymentMethodsTypes
): States.PaymentMethod => {
  switch (action.type) {
    case SET_PAYMENT_METHODS:
      return { ...state, payment_methods: action.payload }
    default:
      return state
  }
}
